import { render, staticRenderFns } from "./SugerenciasPage.vue?vue&type=template&id=6f30c161&lang=pug"
import script from "./SugerenciasPage.vue?vue&type=script&lang=js"
export * from "./SugerenciasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f30c161')) {
      api.createRecord('6f30c161', component.options)
    } else {
      api.reload('6f30c161', component.options)
    }
    module.hot.accept("./SugerenciasPage.vue?vue&type=template&id=6f30c161&lang=pug", function () {
      api.rerender('6f30c161', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/help_center/SugerenciasPage.vue"
export default component.exports